module.exports = __webpack_public_path__ + "img/image_20.420bba30.png";